import { MenuBookDataType } from 'apis/types';
import { ALL_YOU_CAN_EAT_PROPERTY } from '../constants';

export const getListMenubookIdIsNotBuffet = (menubookList: MenuBookDataType) => {
  return Object.values(menubookList)
    .filter(({ property }) => property !== ALL_YOU_CAN_EAT_PROPERTY)
    .map(({ menubook_id }) => menubook_id);
};
